import { Canvas } from "@react-three/fiber";
import ParticleConstellation from "./HeroCanvas/ParticleConstellation";

function HeroCanvas({ mouseRef, darkMode }) {
  return (
    <div className="absolute inset-0" style={{ pointerEvents: "none" }}>
      <Canvas
        camera={{ position: [0, 0, 5], fov: 75 }}
        gl={{ alpha: true, antialias: true }}
        style={{ background: "transparent" }}
      >
        <ParticleConstellation mouseRef={mouseRef} darkMode={darkMode} />
      </Canvas>
    </div>
  );
}

export default HeroCanvas;
